import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Comment.css";
import { useDispatch } from "react-redux";
import { addComment, getViewNotesData } from "../Notes/action";
import { errorToastMessage } from "utils/errorToast";

export default function Comment({ open, onClose, modules, viewNotesId }) {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [heading, setHeading] = useState("Heading 1");
  const [content, setContent] = useState("");
  const [previousContent, setPreviousContent] = useState("");

    // Add this helper function after the isInSameFinancialYear function
  const getPlainTextFromHTML = (htmlString) => {
    // Using DOMParser (most accurate for ReactQuill HTML)
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || doc.body.innerText || "";
  };
  
  const handleSave = async () => {
    // Extract plain text from HTML and validate length
    const plainTextContent = getPlainTextFromHTML(content);
    const trimmedPlainText = plainTextContent.trim();
    const plainTextLength = trimmedPlainText.length;

    if (!trimmedPlainText || plainTextLength === 0) {
      errorToastMessage("Please enter note content");
      return;
    }

    // Add maximum length validation - 2000 characters
    if (plainTextLength > 2000) {
      errorToastMessage(
        `Note content cannot exceed 2000 characters. Current length: ${plainTextLength} characters.`
      );
      return;
    }
    await dispatch(addComment(viewNotesId, content));
    await dispatch(getViewNotesData(viewNotesId));
    handleCancel();
  };
  const handleCancel = () => {
    setContent("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      // PaperProps={{
      //   sx: {
      //     backgroundColor: "#e8e7f0",
      //     borderRadius: "12px",
      //     // padding: "16px"
      //   },
      // }}
    >
      <DialogTitle className="dialog-title">
        {/* Add Comments
        <IconButton
          aria-label="close"
          onClick={onClose}
          // className="close-button"
        >
          <CloseIcon />
        </IconButton> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div></div>
          <Typography
            variant="h6"
            style={{
              textWrap: "wrap",
              wordBreak: "break-word",
              fontWeight: "bold",
            }}
          >
            Add Comments
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent
        style={{
          // boxShadow: "none",
          background: "#f9f5ff",
          // padding: 0
        }}
      >
        <div className="action-buttons">
          <Button
            variant="contained"
            onClick={handleSave}
            // className="save-button"
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              height: "30px",
            }}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            onClick={handleCancel}
            // className="cancel-button"
            style={{
              backgroundColor: "white",
              color: "#4f2d7f",
              textTransform: "capitalize",
              height: "30px",
            }}
          >
            Cancel
          </Button>
        </div>

        <div className="editor-container">
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            placeholder="Write your comment here..."
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
